import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function RobustelliInaugurate() {
  const dateTexts = ['18xx年'];
  const title = 'ロブステリがS.E.A.会長に就任';
  const description = (
    <>
      <a href='/vitale-robustelli'>
        {'ヴィラーレ・ロブステリ'}
      </a>
      {'がS.E.A.の会長に就任する。1800年代のある時期に会長を務めていたようだが、具体的な就任期間はまだ明らかになっていない。'}
    </>
  );

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      important
    />
  );
}

export default RobustelliInaugurate;
